import { DataModel } from "common/models/utility-models/base-model";

export class TerminatePopupModel extends DataModel {
    override id: any = '';
    // name: any = '';
    // email: any = '';
    status_reason: any = '';
    status_remark: any = '';
}